export const STATUS_COLORS = {
  active: "#15BBAE",
  inProgress: "#D9E0E7",
  inactive: "#F45B78",
  inProgressText: "#63788E",
};

export const STATUS_COLOR_VALUES = [
  { label: "Active", color: STATUS_COLORS.active },
  { label: "In Progress", color: STATUS_COLORS.inProgress },
  { label: "Inactive", color: STATUS_COLORS.inactive },
];